
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/course-details/[course_id]",
      function () {
        return require("private-next-pages/course-details/[course_id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/course-details/[course_id]"])
      });
    }
  